import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "@lib/components";
import { Store } from "@lib/components/src/components/table/pro/store";
import { DropWrapper, DropSection } from "@lib/components/src/components/table/pro/components";
import {
	BookingsDateRangeFilter,
	BookingDatePreset,
	bookingDateRangeForPreset,
} from "./bookings-date-range-filter";

interface Props<T> {
	store: Store<T>;
	exportUrl: string;
	region: T.Schema.Restaurant.RestaurantSchema["settings"]["region"];
}

interface State {
	preset: BookingDatePreset;
	start: number;
	end: number;
}

@observer
export class BookingsProtableExport<T> extends React.Component<Props<T>, State> {
	constructor(props: Props<T>) {
		super(props);
		const range = bookingDateRangeForPreset("today", props.region.timezone);
		this.state = {
			preset: "today",
			start: range.start!,
			end: range.end!,
		};
	}

	exportData = () => {
		const { exportUrl } = this.props;
		const { start, end } = this.state;
		window.open(`${exportUrl}&start=${start}&end=${end}`);
	};

	closeExport = () => {
		this.props.store.update({ dropdown: "" });
	};

	render() {
		const { store, region } = this.props;
		const { preset, start, end } = this.state;

		return (
			<DropWrapper active={store.s.dropdown === "export"}>
				<DropSection>
					<h4 className="">CSV Data Export</h4>
					<p className="m-t-2 lhp max700">
						You can export all your data into CSV format which can be used by
						Microsoft Excel and other softwares. Exporting may take a long time
						if you have a large amount of data. It can also place a large load on
						our servers so please do not abuse this feature.
					</p>
				</DropSection>

				<DropSection>
					<p className="big font-semi-bold m-b-3">Export Date Range</p>
					<BookingsDateRangeFilter
						mode="export"
						region={region}
						preset={preset}
						start={start}
						end={end}
						onPresetChange={(nextPreset, range) => {
							this.setState({
								preset: nextPreset,
								start: range.start,
								end: range.end,
							});
						}}
						onRangeChange={(nextStart, nextEnd) => {
							this.setState({
								preset: "custom",
								start: nextStart,
								end: nextEnd,
							});
						}}
					/>
				</DropSection>

				<DropSection>
					<Button
						color="primary"
						size="xs"
						onClick={this.exportData}
						className="m-r-2"
					>
						Export Data
					</Button>
					<Button color="primary-inverse" size="xs" onClick={this.closeExport}>
						Back
					</Button>
				</DropSection>
			</DropWrapper>
		);
	}
}
